<template>
  <div style="width:90%;height:100%;"
       ref="dom"
       class="charts chart-bar"></div>
</template>

<script>
import i18n from '../../locales/index'

import echarts from 'echarts'
import tdTheme from './theme.json'
import { on, off } from '@/libs/tools'
import moment from 'moment';

function getLastWeekDates () {
  const dates = [];
  const m = moment();
  for (let i = 0; i < 7; i++) {
    dates.unshift(m.subtract(1, 'days').format('YYYY-MM-DD'));
  }
  return dates;
}

function getLast24Hours () {
  const now = new Date().getHours();
  const result = [];
  for (let i = 0; i < 24; i++) {
    let hour = now - i - 1;
    if (hour < 0) {
      hour = 24 + hour;
    }
    result.unshift(hour);
  }
  return result;
}

echarts.registerTheme('tdTheme', tdTheme)
export default {
  name: 'ChartBar',
  props: {
    value: Object,
    text: String,
    subtext: String,
    type: String,
  },
  data () {
    return {
      dataSourceBar: null,
      option: {}
    }
  },
  watch: {
    value (val) {
      let xAxisData = this.type === 'daily' ? getLast24Hours() : getLastWeekDates();
      let seriesData = xAxisData.map(i => val[i] || 0);

      const option = {
        // title: {
        //   text: this.text,
        //   subtext: this.subtext,
        //   x: 'center'
        // },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        tooltip: {},
        series: [{
          data: seriesData,
          type: 'bar'
        }]
      }
      this.dataSourceBar.setOption(option)
    }
  },
  methods: {
    resize () {
      this.dataSourceBar.resize()
    }
  },
  mounted () {
    this.dataSourceBar = echarts.init(this.$refs.dom, 'tdTheme')
    on(window, 'resize', this.resize)
  },
  beforeDestroy () {
    off(window, 'resize', this.resize)
  }
}
</script>
